import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-wrap justify-center gap-2 mt-3"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "text-xs font-bold mt-3 text-gray-600"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_6 = { class: "flex items-center justify-end gap-5 w-full mt-5" }
const _hoisted_7 = { class: "text-center py-5" }

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Step = _resolveComponent("Step")
  const _component_StepList = _resolveComponent("StepList")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_IftaLabel = _resolveComponent("IftaLabel")
  const _component_StepPanel = _resolveComponent("StepPanel")
  const _component_BankDetail = _resolveComponent("BankDetail")
  const _component_StepPanels = _resolveComponent("StepPanels")
  const _component_Toast = _resolveComponent("Toast")
  const _component_Stepper = _resolveComponent("Stepper")

  return (_ctx.isBankUpdate)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-gray-800 text-xl font-bold" }, "อัปเดตบัญชี", -1 /* HOISTED */)),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-[12px] mt-2" }, "กรุณาอัปเดตบัญชีธนาคาร", -1 /* HOISTED */)),
        _createVNode(_component_Button, {
          label: "อัปเดตบัญชี",
          onClick: _ctx.btnClickUpdateBank,
          class: "bg-[#753a13]! border-0! mt-4",
          size: "small"
        }, null, 8 /* PROPS */, ["onClick"])
      ]))
    : (_openBlock(), _createBlock(_component_Stepper, {
        key: 1,
        value: _ctx.stepper,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => ((_ctx.stepper) = $event)),
        linear: "",
        pt: {separator:'bg-[#753a13]!'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_StepList, null, {
            default: _withCtx(() => [
              _createVNode(_component_Step, {
                value: "1",
                pt: {header: 'text-xs!', number: 'text-gray-800! text-xs! size-6! min-w-auto!', title:'text-gray-800!'}
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("ระบุจำนวนเงิน")
                ])),
                _: 1 /* STABLE */,
                __: [7]
              }),
              _createVNode(_component_Step, {
                value: "2",
                pt: {header: 'text-xs!', number: 'text-gray-800! text-xs! size-6! min-w-auto!', title:'text-gray-800!'}
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("ฝาก")
                ])),
                _: 1 /* STABLE */,
                __: [8]
              }),
              _createVNode(_component_Step, {
                value: "3",
                pt: {header: 'text-xs!', number: 'text-gray-800! text-xs! size-6! min-w-auto!', title:'text-gray-800!'}
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("สำเร็จ")
                ])),
                _: 1 /* STABLE */,
                __: [9]
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_StepPanels, { pt: {root: 'px-0!'} }, {
            default: _withCtx(() => [
              _createVNode(_component_StepPanel, {
                value: "1",
                pt: {root: 'bg-transparent!'}
              }, {
                default: _withCtx(() => [
                  (_ctx.isActive)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "bg-white border-2! border-[#ff8a1f]! rounded-3xl mb-3 p-2" }, [
                          _createElementVNode("p", { class: "text-gray-800 text-[16px]" }, "⚠️ ฝากถอน ขั้นต่ำ 100 บาท"),
                          _createElementVNode("p", { class: "text-gray-800 text-[14px] py-2" }, "ป้อนจำนวนเงินที่ต้องการฝากด้านล่าง ( ฝากขั้นต่ำ 100 บาท สูงสุด 5,000 บาท )")
                        ], -1 /* HOISTED */)),
                        _createElementVNode("form", {
                          onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                        }, [
                          _createVNode(_component_IftaLabel, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputNumber, {
                                inputId: "amount",
                                mode: "currency",
                                currency: "THB",
                                locale: "th-TH",
                                modelValue: _ctx.form.amount,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.amount) = $event)),
                                class: "w-full",
                                "input-class": "text-gray-800! border"
                              }, null, 8 /* PROPS */, ["modelValue"]),
                              _cache[10] || (_cache[10] = _createElementVNode("label", { for: "amount" }, "ระบุจำนวนเงิน", -1 /* HOISTED */))
                            ]),
                            _: 1 /* STABLE */,
                            __: [10]
                          }),
                          (_ctx.amountLimit.lists.length > 0)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amountLimit.lists, (amount, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: index,
                                    onClick: $event => (_ctx.addAmountInput(amount)),
                                    class: "text-[10px] px-2 py-1 rounded bg-gray-100 hover:bg-gray-200 cursor-pointer"
                                  }, _toDisplayString(Number(amount).toLocaleString()), 9 /* TEXT, PROPS */, _hoisted_3))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_4, " กำลังโหลด... ")),
                          _createVNode(_component_Button, {
                            label: "ฝาก",
                            type: "submit",
                            disabled: _ctx.bankDeposit.active,
                            loading: _ctx.form.btn.loading,
                            size: "small",
                            class: "bg-[#753a13]! border-0! min-w-20 mt-5"
                          }, null, 8 /* PROPS */, ["disabled", "loading"])
                        ], 32 /* NEED_HYDRATION */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[12] || (_cache[12] = [
                        _createElementVNode("h2", { class: "text-gray-800 text-xl font-bold" }, "ปิดให้บริการชั่วคราว", -1 /* HOISTED */),
                        _createElementVNode("p", { class: "text-[12px] text-gray-800 mt-2" }, "ช่องทางฝากนี้ปิดให้บริการชั่วคราว กรุณาลองช่องทางอื่นๆ", -1 /* HOISTED */)
                      ])))
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_StepPanel, {
                value: "2",
                pt: {root: 'bg-transparent!'}
              }, {
                default: _withCtx(() => [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "bg-white border-2! border-[#ff8a1f]! rounded-3xl mb-3 p-2" }, [
                    _createElementVNode("p", { class: "text-gray-800 text-[12px] py-2" }, "โอนเงินจากบัญชีของคุณที่ลงทะเบียน ไปยังเลขบัญชีที่แสดง เงินจะเติมเข้า กระเป๋าเกม ภายใน 5 วินาที")
                  ], -1 /* HOISTED */)),
                  _createVNode(_component_BankDetail, {
                    isActivate: _ctx.bankDeposit.active,
                    isCopyNumber: true,
                    loading: _ctx.bankDeposit.loading,
                    bank: _ctx.bankDeposit.data,
                    showAmount: _ctx.bankDeposit.data.amount,
                    expireTime: _ctx.bankDeposit.data.expireSeconds,
                    onExpired: _ctx.onExpired
                  }, null, 8 /* PROPS */, ["isActivate", "loading", "bank", "showAmount", "expireTime", "onExpired"]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_Button, {
                      onClick: _cache[2] || (_cache[2] = $event => (_ctx.stepper = '3')),
                      size: "small",
                      label: "ถัดไป"
                    })
                  ])
                ]),
                _: 1 /* STABLE */,
                __: [13]
              }),
              _createVNode(_component_StepPanel, {
                value: "3",
                pt: {root: 'bg-transparent!'}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-green-600 text-xl font-bold" }, "เมื่อทำการโอนเงินเรียบร้อยแล้ว", -1 /* HOISTED */)),
                    _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-gray-800 mt-2" }, "ยอดเงินจะถูกเติมเข้า กระเป๋าเกม ภายใน 5 วินาที", -1 /* HOISTED */)),
                    _createVNode(_component_Button, {
                      label: "กลับหน้าหลัก",
                      onClick: _cache[3] || (_cache[3] = $event => (_ctx.stepper = '1')),
                      class: "mt-4"
                    })
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Toast)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["value"]))
}